/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/StatsItemModel',['Solitaire/SolitaireStatistics'], function (SolitaireStatistics) {
    "use strict";

    var StatsItemModel = function (gameMode) {
        this.initStatsItemModel(gameMode);
    };

    StatsItemModel.constructor = StatsItemModel;

    StatsItemModel.prototype.initStatsItemModel = function (gameMode) {
        this.gameMode = gameMode;
        this._stats = [];
        this._updateAllFunc = null;
        this._statKey = null;
        this.isDetailedStats = false;
    };

    StatsItemModel.prototype.addStat = function (stringKey, updateFunc, statKey) {

        var value = updateFunc.call(SolitaireStatistics.Current, statKey);

        this._stats.push({stringKey: stringKey, updateFunc: updateFunc, statKey: statKey, value: value});
    };

    StatsItemModel.prototype.updateStats = function () {
        if (this._updateAllFunc) {
            var stats = this._updateAllFunc.call(SolitaireStatistics.Current, this._statKey);
            for (var i = 0; i < this._stats.length; i++) {
                this._stats[i].value = stats[i];
            }
        }
        else {
            for (var i = 0; i < this._stats.length; i++) {
                this._stats[i].value = this._stats[i].updateFunc.call(SolitaireStatistics.Current, this._stats[i].statKey);
            }
        }
    };

    StatsItemModel.prototype.addStats = function (stringKeys, updateAllFunc, statKey) {
        this._updateAllFunc = updateAllFunc;
        this._statKey = statKey;

        for (var i = 0; i < stringKeys.length; i++) {
            this._stats.push({stringKey: stringKeys[i]});
        }
    };


    StatsItemModel.prototype.getStats = function () {
        return this._stats;
    };

    Object.defineProperty(StatsItemModel.prototype, "StatKey", {
        get: function () {
            return this._statKey;
        }
    });

    return StatsItemModel;


});
